module.exports = __webpack_public_path__ + "img/govTutor.260238a3.png";